<div [class]="'icon-container ' + badgeClass">
  <i [class]="name"></i>
  @if (label) {
    <div class="label">{{ label }}</div>
  }
</div>
